import "./App.css";
import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter } from "react-router";
import { RouteList } from "routes/RouteList";
import { store } from "store/store";
import { NavigationHandler } from "navigation/NavigationHandler";

function App() {
  return (
    <React.Suspense>
      <Provider store={store}>
        <BrowserRouter>
          <NavigationHandler />{" "}
          {/* ✅ This sets global navigate inside Router */}
          <RouteList />
        </BrowserRouter>
      </Provider>
    </React.Suspense>
  );
}

export default App;
